import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const MetaUpdater = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // Базові SEO + Mobile + PWA мета-теги
    ensureMeta('viewport', 'width=device-width, initial-scale=1');
    ensureMeta('apple-mobile-web-app-capable', 'yes');
    ensureMeta('apple-mobile-web-app-status-bar-style', 'default');
    ensureMeta('apple-mobile-web-app-title', 'Serendix');
    ensureMeta('application-name', 'Serendix');
    ensureMeta('theme-color', '#000000');
    ensureMeta('mobile-web-app-capable', 'yes');
    ensureMeta('HandheldFriendly', 'true');
    ensureMeta('MobileOptimized', '320');
    ensureMeta('robots', 'index, follow');
    ensureMeta('googlebot', 'index, follow');
    ensureMeta('bingbot', 'index, follow');
    ensureMeta('rating', 'general');
    ensureMeta('author', 'Serendix Team');
    ensureMeta('copyright', '© 2025 Serendix');
    ensureMeta('language', i18n.language || 'en');

    // Геотаргетинг
    ensureMeta('geo.region', 'UA');
    ensureMeta('geo.placename', 'Lutsk');
    ensureMeta('geo.position', '50.7472;25.3242');
    ensureMeta('ICBM', '50.7472, 25.3242');
  }, []);

  useEffect(() => {
    const path = location.pathname.replace('/', '') || 'home';

    const titleKey = `meta_${path}_title`;
    const descKey = `meta_${path}_description`;
    const keywKey = `meta_${path}_keywords`;

    const title = t(titleKey, { defaultValue: 'Serendix' });
    const description = t(descKey, { defaultValue: 'Welcome to Serendix' });
    const keywords = t(keywKey, {
      defaultValue: 'serendix, web, react, frontend',
    });

    document.title = title;

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    // Hreflang для підтримки 4 мов
    const baseUrl = window.location.origin + location.pathname;
    const langs = ['uk', 'en', 'de', 'pl'];

    langs.forEach((lang) => {
      setHrefLangLink(lang, `${baseUrl}?lng=${lang}`);
    });

    // Додаємо x-default як fallback
    setHrefLangLink('x-default', `${baseUrl}`);
  }, [location, i18n.language]);

  const ensureMeta = (name, content) => {
    let metaTag = document.querySelector(`meta[name="${name}"]`);
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', name);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  const setMeta = (name, content) => {
    let metaTag =
      document.querySelector(`meta[name="${name}"]`) ||
      document.querySelector(`meta[property="${name}"]`);

    if (!metaTag) {
      metaTag = document.createElement('meta');
      if (name.startsWith('og:') || name.startsWith('twitter:')) {
        metaTag.setAttribute('property', name);
      } else {
        metaTag.setAttribute('name', name);
      }
      document.head.appendChild(metaTag);
    }

    metaTag.setAttribute('content', content);
  };

  const setHrefLangLink = (lang, href) => {
    const selector = `link[rel="alternate"][hreflang="${lang}"]`;
    let linkTag = document.querySelector(selector);
    if (!linkTag) {
      linkTag = document.createElement('link');
      linkTag.setAttribute('rel', 'alternate');
      linkTag.setAttribute('hreflang', lang);
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute('href', href);
  };

  return null;
};

export default MetaUpdater;
